export default "__VITE_ASSET__DsbY39xR__"